import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import send from '../send.svg';

import { useEffect, useRef, useState } from 'react';
import { limitToLast, onChildAdded, orderByChild, query, onValue, ref } from 'firebase/database';
import { db, functions } from '../utils/firebase';
import { format, fromUnixTime } from 'date-fns';
import { twMerge } from 'tailwind-merge';
import Logo from '../components/logo';
import useAuth from '../hooks/useAuth';
import { httpsCallable } from 'firebase/functions';

interface Message {
  id: any;
  message: string;
  name: string;
  createdAt: string;
  isCurrentUser: boolean;
}

function getInitial(name: string) {
  // first and very last initial in a name
  return name
    .match(/(\b\S)?/g)
    ?.join('')
    .match(/(^\S|\S$)?/g)
    ?.join('');
}

function ChatPage() {
  const { companyId } = useParams();
  const [message, setMessage] = useState('');
  const [messageList, setMessageList] = useState<Message[]>([]);
  const [user, setUser] = useState<{ id: string; name: string }>();
  const [serviceProvider, setServiceProvider] = useState<{
    id: string;
    name: string;
    station: string;
  }>();

  const effectRanOnce = useRef(false);
  let [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const currentUserId = useAuth();

  const handleMessageChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(target.value);
  };

  useEffect(() => {
    if (effectRanOnce.current === false && companyId) {
      const dbRef = ref(db, `WaitHistoryList/${companyId}/${searchParams.get('id')}`);

      onValue(
        dbRef,
        (snapshot) => {
          const value = snapshot.val();
          console.log('**************** value ****************', value);
          setServiceProvider({
            id: value.providerId,
            name: value.providerName,
            station: value.providerStation,
          });

          setUser({
            id: value.id,
            name: value.name,
          });
        },
        {
          onlyOnce: true,
        }
      );

      return () => {
        effectRanOnce.current = true;
      };
    }
  }, [companyId, searchParams]);

  useEffect(() => {
    if (currentUserId && serviceProvider?.id) {
      console.log(
        '**************** chat node ****************',
        `ChatMessages/${serviceProvider.id}-${currentUserId}`
      );
      const messageRef = query(
        ref(db, `ChatMessages/${serviceProvider.id}-${currentUserId}`),
        orderByChild('createdAt'),
        limitToLast(10)
      );
      const unsubscribe = onChildAdded(messageRef, (snapshot) => {
        const { createdAt, userName, userId, message, name } = snapshot.val();

        const fromNow = format(fromUnixTime(createdAt), 'M/d/yy, h:mm b');

        const isCurrentUser = currentUserId === userId;

        console.log(
          '**************** currentUserId, userId ****************',
          currentUserId,
          userId
        );

        const newMessage = {
          id: snapshot.key,
          createdAt: fromNow,
          message: message,
          name: userName || name,
          isCurrentUser,
        };

        setMessageList((value) => [...value, newMessage]);
      });

      return () => {
        unsubscribe();
      };
    }
  }, [currentUserId, serviceProvider?.id, navigate]);

  const handleSendMessageClick = async () => {
    setMessage('');

    const addMessage = httpsCallable(functions, 'sendMessage');

    const data = {
      historyId: searchParams.get('id'),
      companyId,
      message,
      user: {
        id: currentUserId,
        name: user?.name,
      },
      notify: {
        id: serviceProvider?.id,
        name: serviceProvider?.name,
      },
      chatNode: `${serviceProvider?.id}-${currentUserId}`,
    };
    await addMessage(data);
    // await saveMessage();
  };

  return (
    <div className='flex justify-center flex-col items-center h-screen'>
      <Logo companyId={companyId!}></Logo>

      <p className='text-xl'>{serviceProvider?.name}</p>
      <div className='w-full bg-gray-200 border-b-2'></div>
      <div className='flex flex-col w-full h-full px-5 overflow-scroll'>
        <div className='flex-auto'>
          {messageList.map((message) => {
            const isCurrentUser = message.isCurrentUser;
            const initial = getInitial(message.name);

            return (
              <div className='flex flex-col mb-3' key={message.id}>
                <div className='flex justify-center text-gray-400 mb-2'>{message.createdAt}</div>
                <div className={twMerge('flex', isCurrentUser && 'flex-row-reverse')}>
                  <div
                    className={twMerge(
                      'relative inline-flex items-center justify-center w-10 h-10 overflow-hidden rounded-full',
                      isCurrentUser ? 'ml-3 bg-blue-800' : 'mr-3 bg-gray-600'
                    )}
                  >
                    <span className='text-xl text-white'>{initial}</span>
                  </div>
                  <div
                    className={twMerge(
                      'flex items-center rounded px-3',
                      isCurrentUser ? 'bg-blue-600 text-white' : 'bg-gray-100'
                    )}
                  >
                    {message.message}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className='flex w-full px-5 mb-5'>
        <input
          type='text'
          value={message}
          onChange={handleMessageChange}
          placeholder='Write a message'
          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
        />
        {message !== '' && (
          <img
            src={send}
            className=' ml-5  h-10 w-10'
            alt='Send'
            onClick={handleSendMessageClick}
          />
        )}
      </div>
    </div>
  );
}

export default ChatPage;
